import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

export const GQL_GET_MY_SCORM_TRACKING = typedGql('query', { scalars })({
  getMyScormTracking: {
    id: true,
    completionStatus: true,
    successStatus: true,
    scoreRaw: true,
    scoreMin: true,
    scoreMax: true,
    scoreScaled: true,
    totalTime: true,
    sessionTime: true,
    suspendData: true,
    location: true,
    completedAt: true,
    userId: true,
  },
})

export const GQL_UPSERT_SCORM_TRACKING = typedGql('mutation')({
  upsertScormTracking: [
    {
      input: $('input', 'UpsertScormTrackingInput!'),
    },
    {
      id: true,
      completionStatus: true,
      successStatus: true,
      scoreRaw: true,
      scoreMin: true,
      scoreMax: true,
      scoreScaled: true,
      totalTime: true,
      suspendData: true,
      location: true,
      completedAt: true,
    },
  ],
})

export const GQL_SCORM_TRACKINGS = typedGql('query', { scalars })({
  getScormTrackings: [
    {
      input: $('input', 'FindManyScormTrackingWithFiltersInput!'),
    },
    {
      trackings: {
        id: true,
        completionStatus: true,
        successStatus: true,
        scoreRaw: true,
        scoreMin: true,
        scoreMax: true,
        scoreScaled: true,
        totalTime: true,
        completedAt: true,
        userId: true,
        userEmail: true,
        userFirstName: true,
        userLastName: true,
      },
      total: true,
    },
  ],
})
